module.exports = __webpack_public_path__ + "static/img/loading.16df2454.gif";